import React from 'react';
import { connect } from 'react-redux';
import { SMARTPHONE } from '@/constants';
import { setIsCableFlagSyncState } from '@/actions';
import WizardModePage from './WizardMode';

const WizardModeComponent = props => <WizardModePage {...props} />;

const mapStateToProps = state => ({
  selWizard: state.core.selWizard,
  userSizeUnit: state.core.userSizeUnit,
  pages: state.core.pages,
  pagesSelection: state.core.pagesSelection,
  targetDevice: state.core.targetDevice,
});

const mapDispatchToProps = dispatch => ({
  setIsCableFlagSyncState: (state) => dispatch(setIsCableFlagSyncState(state)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    selWizard,
    cellSelectionType, 
    pages,
    pagesSelection, 
    userSizeUnit,
    targetDevice,
  } = stateProps;

  const {
    setIsCableFlagSyncState
  } = dispatchProps;

  return {
    targetDevice,
    isSmartphone: targetDevice === SMARTPHONE,
    selWizard: selWizard,
    userSizeUnit: userSizeUnit,
    pages: pages,
    pagesSelection: pagesSelection,
    setIsCableFlagSyncState: setIsCableFlagSyncState,
    footerProps: {
      cellSelectionType
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(WizardModeComponent);
